// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Plate$BwaxMobile = require("../../../plate.bs.js");
var Lang_eval$BwaxMobile = require("../../lang_eval.bs.js");
var Runtime_common$BwaxMobile = require("../runtime_common.bs.js");
var Lang_value_dict$BwaxMobile = require("../../lang_value_dict.bs.js");

var module_name = "Dict";

function invalid_args(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        "Dict." + (name + ": Invalid Arguments")
      ];
}

function pack_predicate(f) {
  return (function (k, v) {
      var result = Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
            k,
            /* :: */[
              v,
              /* [] */0
            ]
          ], Runtime_common$BwaxMobile.nt);
      var match = result[0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return Runtime_common$BwaxMobile.invalid_args("some");
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || match$1.tag !== /* Bool */4) {
          return Runtime_common$BwaxMobile.invalid_args("some");
        } else {
          return match$1[0];
        }
      }
    });
}

function func(param) {
  return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.empty(/* () */0));
}

var external_vals_000 = /* tuple */[
  "empty",
  /* tuple */[
    /* V_native_fn */Block.__(4, [
        1,
        func,
        /* [] */0
      ]),
    Runtime_common$BwaxMobile.nt
  ]
];

var external_vals_001 = /* :: */[
  /* tuple */[
    "singleton",
    Runtime_common$BwaxMobile.pack_func(2, (function (param) {
            if (param) {
              var match = param[1];
              if (match && !match[1]) {
                return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.singleton(param[0], match[0]));
              } else {
                return Runtime_common$BwaxMobile.invalid_args("singleton");
              }
            } else {
              return Runtime_common$BwaxMobile.invalid_args("singleton");
            }
          }))
  ],
  /* :: */[
    /* tuple */[
      "insert",
      Runtime_common$BwaxMobile.pack_func(3, (function (param) {
              if (param) {
                var match = param[1];
                if (match) {
                  var match$1 = match[1];
                  if (match$1) {
                    var match$2 = match$1[0][0];
                    if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                      return Runtime_common$BwaxMobile.invalid_args("insert");
                    } else {
                      return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.insert(param[0], match[0], match$2[1]));
                    }
                  } else {
                    return Runtime_common$BwaxMobile.invalid_args("insert");
                  }
                } else {
                  return Runtime_common$BwaxMobile.invalid_args("insert");
                }
              } else {
                return Runtime_common$BwaxMobile.invalid_args("insert");
              }
            }))
    ],
    /* :: */[
      /* tuple */[
        "update",
        Runtime_common$BwaxMobile.pack_func(3, (function (param) {
                if (param) {
                  var match = param[1];
                  if (match) {
                    var match$1 = match[1];
                    if (match$1) {
                      var match$2 = match$1[0][0];
                      if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                        return Runtime_common$BwaxMobile.invalid_args("update");
                      } else {
                        var f = match[0];
                        var update_f = function (v) {
                          var value = Runtime_common$BwaxMobile.pack_maybe((function (x) {
                                  return x;
                                }), v);
                          var result = Lang_eval$BwaxMobile.apply_value(module_name, f, value, Runtime_common$BwaxMobile.nt);
                          var match = result[0];
                          if (typeof match === "number" || !(match.tag === /* V_tagged */6 && match[0] === "Just")) {
                            return ;
                          } else {
                            var match$1 = match[1];
                            if (match$1 && !match$1[1]) {
                              return match$1[0];
                            } else {
                              return ;
                            }
                          }
                        };
                        return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.update(param[0], update_f, match$2[1]));
                      }
                    } else {
                      return Runtime_common$BwaxMobile.invalid_args("update");
                    }
                  } else {
                    return Runtime_common$BwaxMobile.invalid_args("update");
                  }
                } else {
                  return Runtime_common$BwaxMobile.invalid_args("update");
                }
              }))
      ],
      /* :: */[
        /* tuple */[
          "remove",
          Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                  if (param) {
                    var match = param[1];
                    if (match) {
                      var match$1 = match[0][0];
                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                        return Runtime_common$BwaxMobile.invalid_args("remove");
                      } else {
                        return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.remove(param[0], match$1[1]));
                      }
                    } else {
                      return Runtime_common$BwaxMobile.invalid_args("remove");
                    }
                  } else {
                    return Runtime_common$BwaxMobile.invalid_args("remove");
                  }
                }))
        ],
        /* :: */[
          /* tuple */[
            "removeMany",
            Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                    if (param) {
                      var match = param[0][0];
                      if (typeof match === "number" || match.tag !== /* V_list */1) {
                        return Runtime_common$BwaxMobile.invalid_args("removeMany");
                      } else {
                        var match$1 = param[1];
                        if (match$1) {
                          var match$2 = match$1[0][0];
                          if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                            return Runtime_common$BwaxMobile.invalid_args("removeMany");
                          } else {
                            return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.remove_many(match[0], match$2[1]));
                          }
                        } else {
                          return Runtime_common$BwaxMobile.invalid_args("removeMany");
                        }
                      }
                    } else {
                      return Runtime_common$BwaxMobile.invalid_args("removeMany");
                    }
                  }))
          ],
          /* :: */[
            /* tuple */[
              "isEmpty",
              Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                      if (param) {
                        var match = param[0][0];
                        if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                          return Runtime_common$BwaxMobile.invalid_args("isEmpty");
                        } else {
                          return Runtime_common$BwaxMobile.pack_bool(Lang_value_dict$BwaxMobile.is_empty(match[1]));
                        }
                      } else {
                        return Runtime_common$BwaxMobile.invalid_args("isEmpty");
                      }
                    }))
            ],
            /* :: */[
              /* tuple */[
                "member",
                Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                        if (param) {
                          var match = param[1];
                          if (match) {
                            var match$1 = match[0][0];
                            if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                              return Runtime_common$BwaxMobile.invalid_args("member");
                            } else {
                              return Runtime_common$BwaxMobile.pack_bool(Lang_value_dict$BwaxMobile.member(param[0], match$1[1]));
                            }
                          } else {
                            return Runtime_common$BwaxMobile.invalid_args("member");
                          }
                        } else {
                          return Runtime_common$BwaxMobile.invalid_args("member");
                        }
                      }))
              ],
              /* :: */[
                /* tuple */[
                  "get",
                  Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                          if (param) {
                            var match = param[1];
                            if (match) {
                              var match$1 = match[0][0];
                              if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                return Runtime_common$BwaxMobile.invalid_args("get");
                              } else {
                                return Runtime_common$BwaxMobile.pack_maybe((function (x) {
                                              return x;
                                            }), Lang_value_dict$BwaxMobile.get(param[0], match$1[1]));
                              }
                            } else {
                              return Runtime_common$BwaxMobile.invalid_args("get");
                            }
                          } else {
                            return Runtime_common$BwaxMobile.invalid_args("get");
                          }
                        }))
                ],
                /* :: */[
                  /* tuple */[
                    "size",
                    Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                            if (param) {
                              var match = param[0][0];
                              if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                return Runtime_common$BwaxMobile.invalid_args("size");
                              } else {
                                return Runtime_common$BwaxMobile.pack_int(Lang_value_dict$BwaxMobile.size(match[1]));
                              }
                            } else {
                              return Runtime_common$BwaxMobile.invalid_args("size");
                            }
                          }))
                  ],
                  /* :: */[
                    /* tuple */[
                      "some",
                      Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                              if (param) {
                                var match = param[1];
                                if (match) {
                                  var match$1 = match[0][0];
                                  if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                    return Runtime_common$BwaxMobile.invalid_args("some");
                                  } else {
                                    var predicate = pack_predicate(param[0]);
                                    return Runtime_common$BwaxMobile.pack_bool(Lang_value_dict$BwaxMobile.some(predicate, match$1[1]));
                                  }
                                } else {
                                  return Runtime_common$BwaxMobile.invalid_args("some");
                                }
                              } else {
                                return Runtime_common$BwaxMobile.invalid_args("some");
                              }
                            }))
                    ],
                    /* :: */[
                      /* tuple */[
                        "every",
                        Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                if (param) {
                                  var match = param[1];
                                  if (match) {
                                    var match$1 = match[0][0];
                                    if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                      return Runtime_common$BwaxMobile.invalid_args("every");
                                    } else {
                                      var p = pack_predicate(param[0]);
                                      return Runtime_common$BwaxMobile.pack_bool(Lang_value_dict$BwaxMobile.every(p, match$1[1]));
                                    }
                                  } else {
                                    return Runtime_common$BwaxMobile.invalid_args("every");
                                  }
                                } else {
                                  return Runtime_common$BwaxMobile.invalid_args("every");
                                }
                              }))
                      ],
                      /* :: */[
                        /* tuple */[
                          "find",
                          Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                  if (param) {
                                    var match = param[1];
                                    if (match) {
                                      var match$1 = match[0][0];
                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                        return Runtime_common$BwaxMobile.invalid_args("every");
                                      } else {
                                        var p = pack_predicate(param[0]);
                                        var result = Lang_value_dict$BwaxMobile.find(p, match$1[1]);
                                        if (result !== undefined) {
                                          var match$2 = result;
                                          return Runtime_common$BwaxMobile.pack_just(Runtime_common$BwaxMobile.pack_tuple(/* :: */[
                                                          match$2[0],
                                                          /* :: */[
                                                            match$2[1],
                                                            /* [] */0
                                                          ]
                                                        ]));
                                        } else {
                                          return Runtime_common$BwaxMobile.pack_nothing;
                                        }
                                      }
                                    } else {
                                      return Runtime_common$BwaxMobile.invalid_args("every");
                                    }
                                  } else {
                                    return Runtime_common$BwaxMobile.invalid_args("every");
                                  }
                                }))
                        ],
                        /* :: */[
                          /* tuple */[
                            "minimum",
                            Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                    if (param) {
                                      var match = param[0][0];
                                      if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                        return Runtime_common$BwaxMobile.invalid_args("minimum");
                                      } else {
                                        var result = Lang_value_dict$BwaxMobile.minimum(match[1]);
                                        if (result !== undefined) {
                                          var match$1 = result;
                                          return Runtime_common$BwaxMobile.pack_just(Runtime_common$BwaxMobile.pack_tuple(/* :: */[
                                                          match$1[0],
                                                          /* :: */[
                                                            match$1[1],
                                                            /* [] */0
                                                          ]
                                                        ]));
                                        } else {
                                          return Runtime_common$BwaxMobile.pack_nothing;
                                        }
                                      }
                                    } else {
                                      return Runtime_common$BwaxMobile.invalid_args("minimum");
                                    }
                                  }))
                          ],
                          /* :: */[
                            /* tuple */[
                              "maximum",
                              Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                      if (param) {
                                        var match = param[0][0];
                                        if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                          return Runtime_common$BwaxMobile.invalid_args("maximum");
                                        } else {
                                          var result = Lang_value_dict$BwaxMobile.maximum(match[1]);
                                          if (result !== undefined) {
                                            var match$1 = result;
                                            return Runtime_common$BwaxMobile.pack_just(Runtime_common$BwaxMobile.pack_tuple(/* :: */[
                                                            match$1[0],
                                                            /* :: */[
                                                              match$1[1],
                                                              /* [] */0
                                                            ]
                                                          ]));
                                          } else {
                                            return Runtime_common$BwaxMobile.pack_nothing;
                                          }
                                        }
                                      } else {
                                        return Runtime_common$BwaxMobile.invalid_args("maximum");
                                      }
                                    }))
                            ],
                            /* :: */[
                              /* tuple */[
                                "isEqual",
                                Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                        if (param) {
                                          var match = param[0][0];
                                          if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                            return Runtime_common$BwaxMobile.invalid_args("isEqual");
                                          } else {
                                            var match$1 = param[1];
                                            if (match$1) {
                                              var match$2 = match$1[0][0];
                                              if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                return Runtime_common$BwaxMobile.invalid_args("isEqual");
                                              } else {
                                                return Runtime_common$BwaxMobile.pack_bool(Lang_value_dict$BwaxMobile.is_equal(Lang_eval$BwaxMobile.val_equal, match[1], match$2[1]));
                                              }
                                            } else {
                                              return Runtime_common$BwaxMobile.invalid_args("isEqual");
                                            }
                                          }
                                        } else {
                                          return Runtime_common$BwaxMobile.invalid_args("isEqual");
                                        }
                                      }))
                              ],
                              /* :: */[
                                /* tuple */[
                                  "keys",
                                  Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                          if (param) {
                                            var match = param[0][0];
                                            if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                              return Runtime_common$BwaxMobile.invalid_args("keys");
                                            } else {
                                              return Runtime_common$BwaxMobile.pack_list(Lang_value_dict$BwaxMobile.keys(match[1]));
                                            }
                                          } else {
                                            return Runtime_common$BwaxMobile.invalid_args("keys");
                                          }
                                        }))
                                ],
                                /* :: */[
                                  /* tuple */[
                                    "values",
                                    Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                            if (param) {
                                              var match = param[0][0];
                                              if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                return Runtime_common$BwaxMobile.invalid_args("values");
                                              } else {
                                                return Runtime_common$BwaxMobile.pack_list(Lang_value_dict$BwaxMobile.values(match[1]));
                                              }
                                            } else {
                                              return Runtime_common$BwaxMobile.invalid_args("values");
                                            }
                                          }))
                                  ],
                                  /* :: */[
                                    /* tuple */[
                                      "toList",
                                      Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                              if (param) {
                                                var match = param[0][0];
                                                if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                  return Runtime_common$BwaxMobile.invalid_args("toList");
                                                } else {
                                                  return Runtime_common$BwaxMobile.pack_list(Plate$BwaxMobile.List.map((function (param) {
                                                                    return Runtime_common$BwaxMobile.pack_tuple(/* :: */[
                                                                                param[0],
                                                                                /* :: */[
                                                                                  param[1],
                                                                                  /* [] */0
                                                                                ]
                                                                              ]);
                                                                  }), Lang_value_dict$BwaxMobile.to_list(match[1])));
                                                }
                                              } else {
                                                return Runtime_common$BwaxMobile.invalid_args("toList");
                                              }
                                            }))
                                    ],
                                    /* :: */[
                                      /* tuple */[
                                        "fromList",
                                        Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                                                if (param) {
                                                  var match = param[0][0];
                                                  if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
                                                    return Runtime_common$BwaxMobile.invalid_args("fromList");
                                                  } else {
                                                    return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.from_list(Plate$BwaxMobile.List.map((function (param) {
                                                                          var match = param[0];
                                                                          if (typeof match === "number" || match.tag) {
                                                                            return Runtime_common$BwaxMobile.invalid_args("fromList");
                                                                          } else {
                                                                            var match$1 = match[0];
                                                                            if (match$1) {
                                                                              var match$2 = match$1[1];
                                                                              if (match$2 && !match$2[1]) {
                                                                                return /* tuple */[
                                                                                        match$1[0],
                                                                                        match$2[0]
                                                                                      ];
                                                                              } else {
                                                                                return Runtime_common$BwaxMobile.invalid_args("fromList");
                                                                              }
                                                                            } else {
                                                                              return Runtime_common$BwaxMobile.invalid_args("fromList");
                                                                            }
                                                                          }
                                                                        }), match[0])));
                                                  }
                                                } else {
                                                  return Runtime_common$BwaxMobile.invalid_args("fromList");
                                                }
                                              }))
                                      ],
                                      /* :: */[
                                        /* tuple */[
                                          "map",
                                          Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                                  if (param) {
                                                    var match = param[1];
                                                    if (match) {
                                                      var match$1 = match[0][0];
                                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                        return Runtime_common$BwaxMobile.invalid_args("map");
                                                      } else {
                                                        var f = param[0];
                                                        var proc = function (k, v) {
                                                          return Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                                                                      k,
                                                                      /* :: */[
                                                                        v,
                                                                        /* [] */0
                                                                      ]
                                                                    ], Runtime_common$BwaxMobile.nt);
                                                        };
                                                        return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.map(proc, match$1[1]));
                                                      }
                                                    } else {
                                                      return Runtime_common$BwaxMobile.invalid_args("map");
                                                    }
                                                  } else {
                                                    return Runtime_common$BwaxMobile.invalid_args("map");
                                                  }
                                                }))
                                        ],
                                        /* :: */[
                                          /* tuple */[
                                            "foldl",
                                            Runtime_common$BwaxMobile.pack_func(3, (function (param) {
                                                    if (param) {
                                                      var match = param[1];
                                                      if (match) {
                                                        var match$1 = match[1];
                                                        if (match$1) {
                                                          var match$2 = match$1[0][0];
                                                          if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                            return Runtime_common$BwaxMobile.invalid_args("foldl");
                                                          } else {
                                                            var f = param[0];
                                                            var proc = function (acc, k, v) {
                                                              return Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                                                                          acc,
                                                                          /* :: */[
                                                                            k,
                                                                            /* :: */[
                                                                              v,
                                                                              /* [] */0
                                                                            ]
                                                                          ]
                                                                        ], Runtime_common$BwaxMobile.nt);
                                                            };
                                                            return Lang_value_dict$BwaxMobile.foldl(proc, match[0], match$2[1]);
                                                          }
                                                        } else {
                                                          return Runtime_common$BwaxMobile.invalid_args("foldl");
                                                        }
                                                      } else {
                                                        return Runtime_common$BwaxMobile.invalid_args("foldl");
                                                      }
                                                    } else {
                                                      return Runtime_common$BwaxMobile.invalid_args("foldl");
                                                    }
                                                  }))
                                          ],
                                          /* :: */[
                                            /* tuple */[
                                              "filter",
                                              Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                                      if (param) {
                                                        var match = param[1];
                                                        if (match) {
                                                          var match$1 = match[0][0];
                                                          if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                            return Runtime_common$BwaxMobile.invalid_args("filter");
                                                          } else {
                                                            var p = pack_predicate(param[0]);
                                                            return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.filter(p, match$1[1]));
                                                          }
                                                        } else {
                                                          return Runtime_common$BwaxMobile.invalid_args("filter");
                                                        }
                                                      } else {
                                                        return Runtime_common$BwaxMobile.invalid_args("filter");
                                                      }
                                                    }))
                                            ],
                                            /* :: */[
                                              /* tuple */[
                                                "partition",
                                                Runtime_common$BwaxMobile.pack_func(2, (function (param) {
                                                        if (param) {
                                                          var match = param[1];
                                                          if (match) {
                                                            var match$1 = match[0][0];
                                                            if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                              return Runtime_common$BwaxMobile.invalid_args("partition");
                                                            } else {
                                                              var p = pack_predicate(param[0]);
                                                              var match$2 = Lang_value_dict$BwaxMobile.partition(p, match$1[1]);
                                                              return Runtime_common$BwaxMobile.pack_tuple(/* :: */[
                                                                          Runtime_common$BwaxMobile.pack_dict(match$2[0]),
                                                                          /* :: */[
                                                                            Runtime_common$BwaxMobile.pack_dict(match$2[1]),
                                                                            /* [] */0
                                                                          ]
                                                                        ]);
                                                            }
                                                          } else {
                                                            return Runtime_common$BwaxMobile.invalid_args("partition");
                                                          }
                                                        } else {
                                                          return Runtime_common$BwaxMobile.invalid_args("partition");
                                                        }
                                                      }))
                                              ],
                                              /* :: */[
                                                /* tuple */[
                                                  "merge",
                                                  Runtime_common$BwaxMobile.pack_func(3, (function (param) {
                                                          if (param) {
                                                            var match = param[1];
                                                            if (match) {
                                                              var match$1 = match[0][0];
                                                              if (typeof match$1 === "number" || match$1.tag !== /* V_tagged_raw */8) {
                                                                return Runtime_common$BwaxMobile.invalid_args("merge");
                                                              } else {
                                                                var match$2 = match[1];
                                                                if (match$2) {
                                                                  var match$3 = match$2[0][0];
                                                                  if (typeof match$3 === "number" || !(match$3.tag === /* V_tagged_raw */8 && !match$2[1])) {
                                                                    return Runtime_common$BwaxMobile.invalid_args("merge");
                                                                  } else {
                                                                    var f = param[0];
                                                                    var p = function (k, mv1, mv2) {
                                                                      var v1 = Runtime_common$BwaxMobile.pack_maybe((function (x) {
                                                                              return x;
                                                                            }), mv1);
                                                                      var v2 = Runtime_common$BwaxMobile.pack_maybe((function (x) {
                                                                              return x;
                                                                            }), mv2);
                                                                      var result = Lang_eval$BwaxMobile.apply_value_args(module_name, f, /* :: */[
                                                                            k,
                                                                            /* :: */[
                                                                              v1,
                                                                              /* :: */[
                                                                                v2,
                                                                                /* [] */0
                                                                              ]
                                                                            ]
                                                                          ], Runtime_common$BwaxMobile.nt);
                                                                      var match = result[0];
                                                                      if (typeof match === "number" || !(match.tag === /* V_tagged */6 && match[0] === "Just")) {
                                                                        return ;
                                                                      } else {
                                                                        var match$1 = match[1];
                                                                        if (match$1 && !match$1[1]) {
                                                                          return match$1[0];
                                                                        } else {
                                                                          return ;
                                                                        }
                                                                      }
                                                                    };
                                                                    return Runtime_common$BwaxMobile.pack_dict(Lang_value_dict$BwaxMobile.merge(p, match$1[1], match$3[1]));
                                                                  }
                                                                } else {
                                                                  return Runtime_common$BwaxMobile.invalid_args("merge");
                                                                }
                                                              }
                                                            } else {
                                                              return Runtime_common$BwaxMobile.invalid_args("merge");
                                                            }
                                                          } else {
                                                            return Runtime_common$BwaxMobile.invalid_args("merge");
                                                          }
                                                        }))
                                                ],
                                                /* [] */0
                                              ]
                                            ]
                                          ]
                                        ]
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var external_vals = /* :: */[
  external_vals_000,
  external_vals_001
];

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  external_vals
];

var src = "\nmodule Dict;\n\n-- Create an empty dictionary.\nempty: () -> Dict k v = external;\n\n-- Build\n-- Create a dictionary with one key-value pair.\nsingleton: comparable -> v -> Dict comparable v = external;\n\n-- Insert a key-value pair into a dictionary. Replaces value when there is a collision.\ninsert: comparable -> v -> Dict comparable v -> Dict comparable v = external;\n\n-- Update the value of a dictionary for a specific key with a given function.\n-- Depending on the value of y where y is f (get x m), the binding of x is added, removed or updated. \n-- If y is Nothing, the binding is removed if it exists; otherwise, if y is Just z then x is associated to z in the resulting dict.\nupdate: \n    comparable \n  -> (Maybe v -> Maybe v) \n  -> Dict comparable v \n  -> Dict comparable v = external;\n\n-- Remove a key-value pair from a dictionary. If the key is not found, no changes are made.\nremove: comparable -> Dict comparable v -> Dict comparable v = external;\n\n-- Remove the pairs given a list of keys.\nremoveMany: List k -> Dict k v -> Dict k v = external;\n\n\n-- Query\n-- Determine if a dictionary is empty.\nisEmpty: Dict k v -> Bool = external;\n\n-- Determine if a key is in a dictionary.\nmember: comparable -> Dict comparable v -> Bool = external;\n\nhas = member;\n\n-- Get the value associated with a key. If the key is not found, return Nothing. This is useful when you are not sure if a key will be in the dictionary.\nget: comparable -> Dict comparable v -> Maybe v = external;\n\n\n-- Determine the number of key-value pairs in the dictionary.\nsize: Dict k v -> Int = external;\n\n-- Check if some pair passes the given test\nsome: (k -> v -> Bool) -> Dict k v -> Bool = external;\n\nany = some;\n\n-- Check if every pair passes the given test\nevery: (k -> v -> Bool) -> Dict k v -> Bool = external;\n\nall = every;\n\n-- Find the first pair that passes the given test, \n-- Return Nothing there\'s no such a pair.\nfind: (k -> v -> Bool) -> Dict k v -> Maybe (k, v) = external;\n\n-- Returns the pair of the lowest key, or Nothing if not exists.\nminimum: Dict k v -> Maybe (k, v) = external;\n\n-- Return the pair of the highest key, or Nothing if not exists.\nmaximum: Dict k v -> Maybe (k, v) = external;\n\n-- Check if two dicts are equal;\nisEqual: Dict k v -> Dict k v -> Bool = external;\n\n\n-- List related\n-- Get all of the keys in a dictionary, sorted from lowest to highest.\nkeys: Dict k v -> List k = external;\n\n-- Get all of the values in a dictionary, in the order of their keys.\nvalues : Dict k v -> List v = external;\n\n\n-- Convert a dictionary into an association list of key-value pairs, sorted by keys.\ntoList: Dict k v -> List (k, v) = external;\n\n-- Convert an association list into a dictionary.\nfromList: List (comparable, v) -> Dict comparable v = external;\n\n\n-- Transform\n-- Apply a function to all values in a dictionary.\nmap: (k -> a -> b) -> Dict k a -> Dict k b = external;\n\n-- Fold over the key-value pairs in a dictionary from lowest key to highest key.\nfoldl: (acc -> k -> v -> acc) -> acc -> Dict k v -> acc = external;\n\n-- Keep only the key-value pairs that pass the given test.\nfilter: (k -> v -> Bool) -> Dict k v -> Dict k v = external;\n\n\n-- Partition a dictionary according to some test. \n-- The first dictionary contains all key-value pairs which passed the test, and the second contains the pairs that did not.\npartition: (k -> v -> Bool) -> Dict k v -> (Dict k v, Dict k v) = external;\n\n\n-- Combine:\n\n-- A general way of combining two dicts. The function will be called for every key in both dicts.\n-- Given the values in both dicts, the function return some value or Nothing to decide whether the new key value pair is in the returned dict.\nmerge: \n    (k -> Maybe v1 -> Maybe v2 -> Maybe v3)\n  -> Dict k v1\n  -> Dict k v2\n  -> Dict k v3 = external;\n\n-- Combine two dicts. If there is a collision, preference is given to the first dicts.\nunion first second: Dict k v -> Dict k v -> Dict k v =\n  merge \n    (\\k ma mb -> \n      case (ma, mb) of \n      | (Just a, _) -> Just a\n      | (_, Just b) -> Just b \n      | (Nothing, Nothing) -> Nothing)\n    first \n    second\n;\n\n-- Keep a key-value pair when its key appears in the second dict. \n-- Preference is given to values in the first dict.\nintersect first second: Dict k v -> Dict k v -> Dict k v =\n  merge \n    (\\k ma mb -> \n      case (ma, mb) of \n      | (Just a, Just b) -> Just a \n      | (Nothing, Just b) -> Just b \n      | (_, Nothing) -> Nothing)\n    first\n    second\n;\n\n\n-- Keep a key-value pair when its key does not appear in the second dictionary.\ndiff first second: Dict k a -> Dict k b -> Dict k a = \n  merge \n    (\\k ma mb ->\n      case (ma, mb) of \n      | (Just a, Nothing) -> Just a \n      | _ -> Nothing)\n    first \n    second\n;\n\n\n";

exports.src = src;
exports.module_name = module_name;
exports.invalid_args = invalid_args;
exports.pack_predicate = pack_predicate;
exports.external_vals = external_vals;
exports.externals = externals;
/* external_vals Not a pure module */
